// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Transition } from 'framer-motion';

export const defaultTransition: Transition = {
  type: 'spring',
};
